import { forwardRef } from "react";
import type { SVGIconProps } from "../types";

export const AppsIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  function AppsIcon(props, ref) {
    const { size = 24, color = "active", className, ...rest } = props;
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        aria-label="Apps Icon"
        viewBox="0 0 25 24"
        fill={color}
        className={className}
        {...rest}
      >
        <path d="M20.672 4.12c2.477 2.23 2.526 3.172.296 5.649s-3.172 2.526-5.65.296c-2.476-2.23-2.526-3.172-.295-5.65 2.23-2.476 3.172-2.526 5.649-.295Z" />
        <path d="M4 14.592a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4Zm0-9a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4Zm9 9a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4Z" />
      </svg>
    );
  },
);
